<template>
  <v-navigation-drawer
    app
    :expand-on-hover="mini"
    permanent
    :right="mini"
    clipped
    touchless
  >
    <v-list
      nav
      :dense="!mini"
    >
      <v-list-item test-tag="tag-41" link to="/orders/new">
        <v-list-item-icon>
          <v-icon >mdi-note-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-title><T>Новый заказ</T></v-list-item-title>
      </v-list-item>
      <v-list-item test-tag="tag-42" link to="/orders/" exact>
        <v-list-item-icon>
          <v-icon >mdi-format-list-bulleted-type</v-icon>
        </v-list-item-icon>
        <v-list-item-title><T>Список заказов</T></v-list-item-title>
      </v-list-item>
      <v-list-item test-tag="tag-43" link to="/guests/">
        <v-list-item-icon>
          <v-icon >mdi-account-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-title><T>Гости</T></v-list-item-title>
      </v-list-item>
      <!-- <v-list-item test-tag="tag-44" link>
        <v-list-item-icon>
          <v-icon >mdi-run-fast</v-icon>
        </v-list-item-icon>
        <v-list-item-title><T>Курьеры</T></v-list-item-title>
      </v-list-item> -->

      <v-list-group
        v-model="reportsActive"
        prepend-icon="mdi-clipboard-list"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title><T>Отчеты</T></v-list-item-title>
        </template>

        <v-list-item test-tag="tag-45" v-for="(item, index) in reportItems" :key="index" link :to="item.path">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item test-tag="tag-46" link to="/documentation/">
        <v-list-item-icon>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-title><T>Помощь</T></v-list-item-title>
      </v-list-item>
    </v-list>
    <template v-slot:append v-if="$store.getters.user.mode == 'ADMINISTRATOR'">
      <v-list>
        <v-list-item test-tag="tag-47" link to="/settings/">
          <v-list-item-icon>
            <v-icon color="">mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title><T>Параметры</T></v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      reportsActive: false
    };
  },
  props: {
  },
  computed: {
    mini(){
      return this.$vuetify.breakpoint.mdAndDown
    },
    reportItems() {
      return [
        { title: this.$t('Удаленные заказы'), path: '/reports/remoteOrder' },
        { title: this.$t('Отчет по гостям'), path: '/reports/guestsOrder' },
        { title: this.$t('Отчет по деньгам'), path: '/reports/cashReport' },
        { title: this.$t('Картина дня'), path: '/reports/dayPicture' },
        { title: this.$t('Отчет по зонам доставки'), path: '/reports/deliveryZonesReport' },
        { title: this.$t('Дашборд'), path: '/reports/dashboard' }
      ];
    }
  }
}
</script>